module.exports = __webpack_public_path__ + "img/18_2.6778cdbf.png";